import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { fg } from '@confluence/feature-gating';
import { preloadReadTime } from '@confluence/read-time/entry-points/preloadReadTime.ts';
import { preloadPageReactions } from '@confluence/reactions/entry-points/preloadPageReactions.ts';
import { preloadClassificationContextForViewContent } from '@confluence/data-classification/entry-points/queries.ts';
import { preloadContentAnalyticsViewers } from '@confluence/confluence-analytics/entry-points/preloadContentAnalyticsViewers.js';

import { ContentHeaderUnifiedQuery } from '../ContentHeaderUnifiedQuery.graphql.ts';
import { DEFAULT_CONTRIBUTORS_FETCH_LIMIT } from '../defaultQueryVariables.js';

export type preloadEditorByLineDataProps = {
	isUnpublishedDraft?: boolean;
	spaceKey?: string;
	contentId: string;
};

export function preloadEditorByLineData({
	isUnpublishedDraft,
	spaceKey,
	contentId,
}: preloadEditorByLineDataProps) {
	const queries: Promise<any>[] = [];

	if (fg('cc_page_experiences_new_editor_byline')) {
		queries.push(
			query({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: ContentHeaderUnifiedQuery,
				variables: {
					contentId,
					spaceKey,
					versionOverride: null,
					embeddedContentRender: null,
					limit: DEFAULT_CONTRIBUTORS_FETCH_LIMIT,
					includeGeneratedBy: fg('cc-activation-user-generated-by-byline'),
					...(isUnpublishedDraft && { status: ['draft'] }),
				},
			}),
		);

		queries.push(
			preloadPageReactions({
				pageId: contentId,
				containerId: spaceKey,
			}),
		);

		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		if (process.env.REACT_SSR) {
			queries.push(
				preloadReadTime({ contentId, useCache: false, status: ['current', 'draft'] }),
				preloadContentAnalyticsViewers(contentId),
				preloadClassificationContextForViewContent(contentId),
			);
		}
	}

	return waitForAllReturnWhenError(queries);
}
